import { useEffect } from 'react'
//import { GetGenderMode } from './../../../utilities/BL/Zones'


const Welcome = ({ isActiveWomensMode }) => {
    //const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)


    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")


            // const response = await GetGenderMode()

            // if (response.success) {
            //     setIsActiveWomensMode(response.data.isWomensModeActive)
            // } else {
            //     setIsActiveWomensMode(false)
            // }
        } catch (error) {

        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            {/* Encabezado */}
            <div className='Screen__Welcome__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='Screen__Welcome__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/background.png' className='Screen__Welcome__Background__Image' />
                )}
                
                {/* <img src='/img/page/backgrounds/background.png' className='Screen__Welcome__Background__Image' /> */}
                {/* <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='Screen__Welcome__Background__Image' /> */}
            </div>

            {/* Contenido */}
            <section className="Screen__Welcome__Container Container-FullHeight">
                {/* <div className='Screen__Welcome__Container__QR'>
                    <img src="/img/page/qr/home-qr-fondo-gris-sin-parametros.png" className="Screen__Welcome__Container__QR__Image" alt="Logo" />
                </div>

                <div className='Screen__Welcome__Container__Info'>
                    <img src="/img/page/adsl-five.png" className="Screen__Welcome__Container__Info__Image" alt="Logo" style={{ width: '600px' }} />
                    <p className='Screen__Welcome__Container__Text' style={{ fontSize: '4em' }}>ESCANEA EL CÓDIGO</p>
                    <p className='Screen__Welcome__Container__Text' style={{ fontSize: '4em' }}>Y PARTICIPA PARA GANAR</p>
                    <p className='Screen__Welcome__Container__Text' style={{ marginTop: '1em', fontSize: '4em' }}>#PORTITODOSINTINADA</p>
                </div> */}

                <div className='Screen__Welcome__Container__QR'>
                    <img src="/img/page/adsl-five.png" className="Screen__Welcome__Container__Info__Image" alt="Logo" style={{ width: '600px', marginTop: '120px' }} />
                    <p className='Screen__Welcome__Container__Text' style={{ fontSize: '4em', marginTop: '50px' }}>ESCANEA EL CÓDIGO</p>
                    <p className='Screen__Welcome__Container__Text' style={{ fontSize: '4em' }}>Y PARTICIPA PARA GANAR</p>
                    <p className='Screen__Welcome__Container__Text' style={{ marginTop: '150px', fontSize: '4em' }}>#PORTITODOSINTINADA</p>
                </div>

                <div className='Screen__Welcome__Container__Info ms-5'>
                    <img src="/img/page/qr/home-qr-fondo-gris-sin-parametros.png" className="Screen__Welcome__Container__QR__Image" alt="Logo" />
                </div>
            </section>

            {/* Pie de página */}
            {/* <footer className='Screen__Welcome__Footer'>
                <p className='text-center FooterCredits'>Hecho con ♥ por Interaktia | 2026</p>
            </footer> */}
        </>
    )
}

export { Welcome };





{/* <section className="Screen__Welcome Container-FullHeight">
    <div className='Screen__Welcome__QR'>
        <img src="/img/page/qr-inicio-fdm.png" className="Screen__Welcome__QR__Image" alt="Logo" />
    </div>
    <div className='Screen__Welcome__Info'>
        {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" /> /}
        <img src="/img/page/adsl-five.png" className="Screen__Welcome__Info__Image" alt="Logo" />
        <p className='Screen__Welcome__Text'>Escanea el código</p>
        <p className='Screen__Welcome__Text'>o ingresa a</p>
        {/* Aquí se debe colocar la imagen del código QR (utm_source = screen) /}
        <p className='Screen__Welcome__Text Screen__Welcome__Text--Highlight'>WWW.ADSL.MX</p>
    </div>
    {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" />
    <p className='Screen__Welcome__Text'>Únete escaneando el código</p>
    {/* Aquí se debe colocar la imagen del código QR (utm_source = screen) /}
    <img src="/img/page/qr-inicio-fdm.png" className="Screen__Welcome__QR" alt="Logo" />
    <p className='Screen__Welcome__Text'>O ingresando a  WWW.ADSL.MX</p> /}
</section>

<footer className='container'>
    <p className='text-center'>Hecho con ♥ por Interaktia | 2026</p>
</footer> */}